/* istanbul ignore file */

import type { ChangeEvent } from 'react';
import React from 'react';
import { Radio } from '@noths/polaris-client-ribbons-design-system';

import {
  RADIO_BUTTON__LABEL_CLASS,
  RADIO_BUTTON__LABEL_TEXT_CLASS,
} from 'src/components/atoms/RadioButton/classNames';
import * as styles from 'src/components/atoms/RadioButton/RadioButton.styles';

export type RadioButtonProps = {
  checked?: boolean;
  invalid?: boolean;
  labelText: string;
  name?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  value: string;
};

export const RadioButton = ({
  checked = false,
  invalid = false,
  labelText,
  name,
  onChange,
  required,
  value,
  ...props
}: RadioButtonProps) => (
  <label className={RADIO_BUTTON__LABEL_CLASS} css={styles.radioButtonWrapper}>
    <Radio
      aria-invalid={invalid}
      aria-label={labelText}
      checked={checked}
      name={name}
      onChange={onChange}
      required={required}
      value={value}
      {...props}
    />
    <span
      aria-hidden="true"
      className={RADIO_BUTTON__LABEL_TEXT_CLASS}
      css={styles.radioButtonLabelText}
    >
      {labelText}
    </span>
  </label>
);
